module.exports = __webpack_public_path__ + "static/media/6.question.99556399.mp4";